const notificationlogs = {
	title: "Varslingshistorikk",
	type: "Type",
	slug: "Slug",
	subject: "Email subject / SMS message",
	message: "Message",
	recipient: "Recipient",
	date_sent: "Date sent",
	status: "Status",
	sender: "Avsender",
	system_triggered: "Systemgenerert",
};
export default notificationlogs;